import { useMemo } from 'react'

export const useValuesFlat = () => {
  // Function to flatten a nested object
  const toFlat = (
    values: Record<string, any>,
    parentKey = '',
    result: Record<string, any> = {},
  ): Record<string, any> => {
    if (!values) {
      return values
    }

    for (const key of Object.keys(values)) {
      const keyFull = parentKey ? `${parentKey}.${key}` : key
      const value = values[key]

      if (value && typeof value === 'object' && !Array.isArray(value)) {
        toFlat(value, keyFull, result) // Recursively flatten nested objects
      } else {
        result[keyFull] = value // Add non-object values directly
      }
    }
    return result
  }

  // Function to reconstruct a flat object into a nested object
  const toObject = (values: Record<string, any>): Record<string, any> => {
    if (!values) {
      return values
    }

    const result: Record<string, any> = {}

    for (const flatKey of Object.keys(values)) {
      const value = values[flatKey]
      const keys = flatKey.split('.') // Split the key into its parts

      let current = result

      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          current[key] = value // Assign the value at the final key
        } else {
          current[key] = current[key] ?? {} // Create an object if it doesn't exist
          current = current[key]
        }
      })
    }
    return result
  }

  return useMemo(() => ({ toFlat, toObject }), [])
}
